export default __webpack_public_path__ + "static/media/ic-background.321573dc.svg";